// extracted by mini-css-extract-plugin
export var numpadContainer = "_lt-1";
export var phoneButton = "_lt-0";